<template>
  <v-container fluid class="archive-page">
    

    <archive-table
      :items="contracts"
      :loading="loading"
      :total-items="totalItems"
      :page.sync="page"
      :size.sync="size"
      @action="onTableAction"
    />

    <archive-contract-dialog
      :contract="selectedContract"
      v-model="showDetailsDialog"
    />

    <confirm-restore-dialog
      :contract="selectedContract"
      v-model="showRestoreDialog"
      @confirmed="onConfirmedRestore"
    />

    <confirm-permanent-delete-dialog
      :contract="selectedContract"
      v-model="showPermanentDeleteDialog"
      @confirmed="onConfirmedPermanentDelete"
    />
  </v-container>
</template>

<script>
import ArchiveTable from '@/components/archive/ArchiveTable.vue'
import ArchiveContractDialog from '@/components/archive/dialogs/ArchiveContractDialog.vue'
import ConfirmRestoreDialog from '@/components/archive/dialogs/ConfirmRestoreDialog.vue'
import ConfirmPermanentDeleteDialog from '@/components/archive/dialogs/ConfirmPermanentDeleteDialog.vue'
import axios from 'axios'

export default {
  name: 'ArchiveView',
  components: {
    ArchiveTable,
    ArchiveContractDialog,
    ConfirmRestoreDialog,
    ConfirmPermanentDeleteDialog
  },
  data() {
    return {
      filters: { search: '', dateFrom: null, dateTo: null },
      contracts: [],
      loading: false,
      totalItems: 0,
      page: 1,
      size: 100,
      selectedContract: null,
      showDetailsDialog: false,
      showRestoreDialog: false,
      showPermanentDeleteDialog: false
    }
  },
  methods: {
    async fetchArchives() {
      this.loading = true
      try {
        const res = await axios.get('admin/contract2025/get/deleted', {
          params: {
            ...this.filters,
            page: this.page - 1,
            size: this.size,
            locale: this.$i18n.locale    // <-- add this
          }
        })
        this.contracts  = res.data.content
        this.totalItems = res.data.totalElements
      } finally {
        this.loading = false
      }
    },


    onTableAction({ type, item }) {
      this.selectedContract = item
      switch (type) {
        case 'view':   this.showDetailsDialog = true; break
        case 'restore': this.showRestoreDialog = true; break
        case 'delete': this.showPermanentDeleteDialog = true; break
      }
    },

    async onConfirmedRestore() {
      await axios.put(
        `admin/contract2025/restore/${this.selectedContract.id}`
      )
      this.fetchArchives()
    },


    async onConfirmedPermanentDelete() {
      await axios.delete(
        `/api/v1/admin/contract2025/${this.selectedContract.id}`
      )
      this.showPermanentDeleteDialog = false
      this.fetchArchives()
    }
  },

  mounted() {
    this.fetchArchives()
  },

    watch: {
    // whenever the user clicks “2,3,4…” or picks a new page‐size
    page() {
      this.fetchArchives()
    },
    size() {
      this.fetchArchives()
    }
  }

}
</script>

<style scoped>
.archive-page {
  padding: 24px;
  max-width: 1200px;
  margin: auto;
  border-radius: 8px;
}
</style>
